import { Sparkles, Heart } from "lucide-react";
import { HostStockBadge } from "@/components/find-my-size/HostStockBadge";
import { FIT_LABEL_MAP, buildProfileChips } from "../constants";
import { InfoNote } from "../parts/InfoNote";
import { ProfileChipList } from "../parts/ProfileChipList";

// ═══════════════════════════════════════════════════════════════════════════
// STEP: Sonuç
// ═══════════════════════════════════════════════════════════════════════════
export const ResultStep = ({ recommendation, profile, copy, outOfRangeStrategy, previewRefusal, accent, hostStockStatus }) => {
    const { size, outOfRange } = recommendation;
    const showRefusal = previewRefusal || (outOfRange && outOfRangeStrategy === "kind_refusal");
    const hostOOS = hostStockStatus === "out-of-stock";

    if (showRefusal) {
        return (
            <div className="flex flex-col items-center justify-center text-center py-4 space-y-4 min-h-full" data-testid="fms-step-result-refusal">
                <span
                    className="inline-flex h-12 w-12 items-center justify-center rounded-full sayz-fms-reveal"
                    style={{ background: accent, color: "#fff", animationDelay: "0ms" }}
                >
                    <Heart className="h-5 w-5" strokeWidth={1.75} fill="currentColor" />
                </span>
                <span
                    className="text-[11px] font-semibold uppercase tracking-wider sayz-fms-reveal"
                    style={{ color: accent, animationDelay: "80ms" }}
                >
                    {copy.refusalLabel || "Emin değiliz"}
                </span>
                <p
                    className="text-[15px] text-foreground leading-relaxed max-w-[360px] sayz-fms-reveal"
                    style={{ animationDelay: "160ms" }}
                >
                    {copy.refusalText || "Bu ürün için sana ideal bedeni tam olarak bulamadık. Yanlış bedenle iade yaşamamak için beden tablosunu incelemeni öneririm."}
                </p>
            </div>
        );
    }

    const chips = buildProfileChips(profile);

    return (
        <div className="flex flex-col items-center justify-center text-center space-y-5 min-h-full" data-testid="fms-step-result">
            {/* İkon */}
            <span
                className="inline-flex h-11 w-11 items-center justify-center rounded-full sayz-fms-reveal"
                style={{ background: accent, color: "#fff", animationDelay: "0ms" }}
            >
                <Sparkles className="h-[18px] w-[18px]" strokeWidth={1.75} />
            </span>

            {/* ÖNERİMİZ label */}
            <span
                className="text-[11px] font-semibold uppercase tracking-wider sayz-fms-reveal"
                style={{ color: accent, animationDelay: "60ms" }}
            >
                {copy.resultLabel || "Önerimiz"}
            </span>

            {/* Açıklama başlığı — ürüne göre öneri */}
            <p
                className="text-[13.5px] text-muted-foreground leading-relaxed max-w-[360px] sayz-fms-reveal"
                style={{ animationDelay: "120ms", marginTop: "0.25rem" }}
            >
                {copy.resultText || "Vücut bilgilerin ve fit tercihine göre bu ürün için önerdiğimiz beden."}
            </p>

            {/* Öneri bedeni — host DOM'da stokta yoksa 55% opak + hairline
                strike (HostStockBadge içinde) ile "available but not now"
                hissi veriyoruz. Beden hero olarak hâlâ okunur, ama görsel
                olarak önceliği stok uyarısına bırakıyor. */}
            <div
                className="font-bold tracking-tight leading-none text-foreground tabular-nums sayz-fms-reveal"
                style={{
                    fontSize: "72px",
                    letterSpacing: "-0.03em",
                    animationDelay: "180ms",
                    marginTop: "0.5rem",
                    opacity: hostOOS ? 0.55 : 1,
                    transition: "opacity 220ms ease",
                }}
                data-testid="fms-recommended-size"
            >
                {size}
            </div>

            {/* Host DOM stock cue — luxury typographic signal (no green
                ticks). Rendered right under the size letter so it reads
                as a confidence stamp, not a popup. See HostStockBadge for
                the editorial design decisions. */}
            {hostStockStatus && hostStockStatus !== "disabled" && hostStockStatus !== "not-found" && (
                <div className="sayz-fms-reveal" style={{ animationDelay: "220ms", marginTop: "0.25rem" }}>
                    <HostStockBadge status={hostStockStatus} accent={accent} />
                </div>
            )}

            {/* Fit info — Karşılama Tam'daki info notuyla aynı stil (i ikonu + ortalı) */}
            {profile.fit && (
                <InfoNote testId="fms-result-fit-reminder" animationDelay="240ms">
                    <span className="text-foreground font-semibold">{FIT_LABEL_MAP[profile.fit]}</span> tercihine göre hesapladık.
                </InfoNote>
            )}

            {/* Bildiklerimiz — ortalı chip özeti */}
            {chips.length > 0 && (
                <ProfileChipList chips={chips} centered />
            )}
        </div>
    );
};
